// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online Ultimate',
  freeTimesLimitTitle: 'Die kostenlose Testversion ist heute abgelaufen.',
  fileSizeLimitTitle:
    'Die Dateigröße darf in der kostenlosen Version 20 MB nicht überschreiten.',
  freeImgCutoutTimesLimitTitle:
    'Die heutige Testversion der Funktion "Hintergrund entfernen" ist abgelaufen. Aktualisieren Sie auf die "Pro"-Version, um alle erweiterten Funktionen zu erhalten.',
  total: 'Gesamt',
  enterCode: 'Code eingeben',
  signUpToPurchaseBtn: 'Anmelden und kaufen',
  goPurchseBtn: 'Zum Einkaufen gehen',
  saveTips: 'Sparen Sie bis zu {{num}}%',
  discount: 'Rabatt',
  priceWeek: '9,99€',
  priceMonth: '7,49€',
  priceYear: '3,75€',
  billedMonth: '29,99€ Monatlich abgerechnet',
  billedYear: '179,99€ Monatlich abgerechnet',
  week: 'Woche',
  weekly: 'Wöchentlich',
  monthly: 'Monatlich',
  yearly: 'Jährlich',
  AlreadySubscribe: 'Bereits abonniert?',
  vipTips1: 'Keine Dateigrößenbeschränkung',
  vipTips2: 'Keine Begrenzung der Anzahl der verarbeiteten Dateien',
  vipTips3: 'Bildhintergründe unbegrenzt ändern',
  vipTips4: 'Zugang zu allen kostenlosen Tools und Premium-Funktionen',
  purchaseTips: 'Automatische Verlängerung und jederzeitige Kündigung.',
  tips: 'Hinweise:',
  promoCodeInvalidTips: 'Ihr Promo-Code ist ungültig',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
